import Account from '@/pages/account/account.vue'
import Login from '@/pages/account/login/login.vue'
import Register from '@/pages/account/register/register.vue'
import ServiceProtocol from '@/pages/personal-center/about/service-protocol.vue'

const AccountRoutes = {
  path: '/account',
  name: 'account',
  component: Account,
  redirect: {
    name: 'login'
  },
  children: [
    {
      path: 'login',
      name: 'login',
      component: Login
    },
    {
      path: 'register',
      name: 'register',
      component: Register
    },
    {
      path: 'serviceprotocol',
      name: 'serviceprotocol',
      component: ServiceProtocol
    }
  ]
}

export default AccountRoutes
